import { colors } from 'bench-style-constants';
import onClickOutside from 'react-onclickoutside';
import React, { Component } from 'react';
import styled from 'styled-components';
import { bindHotKeysToDocument, unBindHotKeysFromDocument } from './hotKeys';

const RightSidebar = styled.div`
  background: ${colors.white};
  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 4px 5px 0 rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.16);
  width: 450px;
  overflow: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
`;

type DismissableSidebarProps = {
  children: React.ReactNode;
  dismissSidebar: () => any;
};

class DismissableRightSidebar extends Component<DismissableSidebarProps> {
  constructor(props) {
    super(props);

    this.hotKeyMap = {
      esc: () => this.props.dismissSidebar(),
    };
  }

  componentDidMount() {
    bindHotKeysToDocument(this.hotKeyMap);
  }

  componentWillUnmount() {
    unBindHotKeysFromDocument(this.hotKeyMap);
  }

  // Used by `onClickOutside` to handle clicks on the document to dismiss the sidebar
  handleClickOutside = (mouseEvent: any) => {
    const shouldDismissSidebar =
      !!mouseEvent &&
      !!mouseEvent.path &&
      !mouseEvent.path.some(
        element => element && element.matches && element.matches('[data-bypass-dismiss-sidebar]'),
      );
    if (shouldDismissSidebar) {
      this.props.dismissSidebar();
    }
  };

  hotKeyMap = {};

  render() {
    return <RightSidebar>{this.props.children}</RightSidebar>;
  }
}

export default onClickOutside(DismissableRightSidebar);
